import {
  Component,
  Input, Output,
  OnInit,
  TemplateRef,
  ViewEncapsulation,
  OnDestroy,
  ElementRef,
  ViewChild,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core';



//
// Store Interface
//
import { Store } from '@ngrx/store';
import { isNil } from 'lodash';

import { IAppCoreState } from '../../../state';
import { SubSink } from 'subsink';
import { SharedFunctionService } from '../../../services/shared-func.service';
import { SharedDataService } from '../../../services/shared-data.service';
import { getAppNavBar } from 'src/app/core/state/selectors';
import { AppNavBarOpenDialog } from 'src/app/core/state/actions/app-navbar.action';
import { WebSocketManagerService, SocketPayloadType } from '../../../services/websocket-manager.service';

import { Event, Router, NavigationStart, NavigationEnd } from '@angular/router';

import * as fromSelector from '../../../state/selectors/index';
import * as appNotificationsActions from '../../../state/actions/app-notification.action';
import { SocketPayload } from 'src/app/shared/model/api/SocketPayload';
import { AudioService } from 'src/app/core/services/audio.service';
import { ViewConstants } from 'src/app/constants';
import { CdkMessageService } from 'src/app/shared/model/common/sdk-message';
import { Action } from 'src/assets/core';
import { ToastrService } from 'ngx-toastr';
import { ConAppToaster } from '../con-app-toaster/con-app-toaster';
import { CaptureAnalyticsService } from 'src/app/core/services/capture-analytics.service';
import { FeatureFlagService } from 'src/app/environment/services/feature-flag.service';
@Component({
    selector: 'con-app-navbar',
    templateUrl: 'con-app-navbar.html',
    styleUrls: ['con-app-navbar.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConAppNavBar implements OnInit, OnDestroy {
  @Input('template') public toolbarTemplate: TemplateRef<any>;
  @Input() public disabled: boolean;
  @Input() public hidden: boolean;
  // public delearName: string = '';

  @Output() emitPathValue = new EventEmitter();
  @ViewChild('profileTemplate', {static: false}) profileTemplate: ElementRef;
  @ViewChild('messagesTemplate', {static: false}) messagesTemplate: ElementRef;
  @ViewChild('superMenuTemplate', {static: false}) superMenuTemplate: ElementRef;

  //
  // Public Variables
  //
  public model: any;
  public profileData: any = [];
  public navAction: Action;
  //
  // Subscriptions
  //
  private readonly subs = new SubSink();
  public modalDialog: any;
  public navBarPopUpClose: boolean;
  public currentScreen: string;
  public openunsaveWriteupsDialog: boolean;

  //
  // notification
  //
  public hasNotification = false;
  public newNotification = false;
  public newMessage = false;
  public interval: any;
  public messageInterval:any;
  //
  // is app online(socket connected) 
  //
  public isOnline = false;
  public hasComment = false;
  public dealerCode: string;
  public dealerName: string;
  private count=0;
  private messagecount=0;
  public toggleProfileTemplateFlag = false;
  private readonly path = '/wl/summary';
  //public notifications : DealSummaryView = null;

  /**
   * constructor()
   */
  constructor(
    private readonly _store: Store<IAppCoreState>,
    public readonly _sharedDataService: SharedDataService,
    public readonly _sharedFuncService: SharedFunctionService,
    private readonly toastrService: ToastrService,
    private readonly audioService: AudioService,
    public readonly router: Router,
    private readonly webSocketManager: WebSocketManagerService,
    private readonly _modalService: CdkMessageService,
    private readonly cdRef : ChangeDetectorRef,
    private readonly analyticsService: CaptureAnalyticsService,
    private readonly featureFlagService: FeatureFlagService
  ) {
    this.disabled = false;
    this.hidden = false;
    this.model = {};
  }

  public ngOnInit() {
    this._sharedDataService.profileTemplateToggleSubject.subscribe(flag => this.toggleProfileTemplateFlag = flag);
    //
    // Only if on summary screen, show super menu
    // Else show back
    //
    this.currentScreen = 'notsummary';
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if (event.url === this.path){
          this.currentScreen = 'summary';
        }
        else{
          this.currentScreen = "notsummary";
        }
      }
      if (event instanceof NavigationEnd) {
        if (event.url === this.path || event.urlAfterRedirects  === this.path) {
          this.currentScreen = 'summary';
        }
        else {
          this.currentScreen = "notsummary";
        }
        if (event.url.indexOf('/cv') !== -1) {
          this.hidden = true;
        } else {
          this.hidden = false;
        }
      }
    });
    //
    // in case url of a feature module is directly typed in address bar, 
    // the above router event wont happen.
    // so the below code will only be executed once and take care of that situation
    // 
    if (this.router.url === this.path || this.router.url === '/') {
      this.currentScreen = 'summary';
    }
    //
    // Get Menu Items
    //
    this.subs.sink =
      this._store.select(getAppNavBar).subscribe(state => {
        //
        // Set Active menu
        // 
        this.model = state;
        this.dealerCode = this._sharedDataService.dealerCode;

        if (this.model?.avatar?.name) {
          const profileInfo: any = this.model.avatar.name;
          this.profileData = profileInfo.toUpperCase();
          this._sharedDataService.managerName=this.profileData;
          this.model.avatar.onClick = () => {
            this._sharedDataService.profileTemplateToggleSubject.next(true);
            setTimeout(() => {
              if(document.getElementById("con-app-logout-div"))
              {
                document.getElementById("con-app-logout-div").focus();
              }
           }, 500);
          }
          this.model.notification.onClick = () => {
            this.count=0;
            this.newNotification = false; 
            clearInterval(this.interval);
            this._store.dispatch(appNotificationsActions.AppNotificationShowPanel());
          }
          this.model.menu.onClick = () => {
            const payload = {
              template: this.superMenuTemplate,
              data: {},
              style: {
                // right: '100px',
                top: '200px',
                left: '50%',
                width: '800px',
                height: '300px',
                'background-color': 'white',
                'border-radius': 'gray',
                'margin-left': 'auto',
                'margin-right': 'auto'
              }
            };
            this._store.dispatch(AppNavBarOpenDialog({payload}));
          }
        }
      });


    //
    // dispatch fetch notification action. wont issue an http call if not authorized
    //
    this._store.dispatch(appNotificationsActions.AppNotificationInitialFetch());

    //
    // has notification?. maybe better off to remove this state and figure it out with notifications
    //
    this.subs.sink = this._store.select(fromSelector.selectHasAppNotification).subscribe(hasNotification => {
      this.hasNotification = hasNotification;
    }
    );
    //
    // is app online ( is socket connected?)
    //
    this.subs.sink = this._store.select(fromSelector.selectAppOnlineStatus).subscribe(isOnline => {
      this.isOnline = isOnline;
    }
    );
    this.subs.sink = this._store.select(fromSelector.selectAppToasts).subscribe(toasts => {
      this.newNotification = true;
      clearInterval(this.interval);
      this.startBlink();
      toasts = toasts.filter( item => item.deal.onlineStatus != ViewConstants.ONLINE_STATUS_READY_FOR_DEALER)
      this.notificationToast(toasts)
    });

    //
    // connect the socket
    //
    this.webSocketManager.connect();
    //
    // listen to incoming notification
    //
    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.Notification).subscribe(e => {
      const status= e.payload.deal.status;
      const customer = e?.payload?.customer;
      const coBuyer = e?.payload?.cobuyer;
      let showToast=false;
      this._sharedDataService.toastChatType=false;
      if(!e.payload.deal.salesPersonComments){
        const reviewManager = e?.payload?.deal?.reviewManager;
        const loggedInUser = reviewManager?.filter(e => e.id.toString().toLowerCase() === this._sharedDataService.loggedInUserId.toString().toLowerCase())
        if(reviewManager?.length > 0 && loggedInUser?.length > 0){
          showToast=true;
        }
        const isMessage = status === "Message";
        const payload = {
            deal: {
              dealTransactionId: e.payload.deal.dealTransactionId,
              dealType: e.payload.deal.dealType,
              paymentType: e.payload.deal.paymentType,
              status: status,
              onlineStatus: this._sharedDataService.getOnlineStatus(e.payload.deal),
              updatedDate: e.payload.deal.updatedDate,
              salesPersonComments: isMessage,
              salesPerson: isMessage ? e.payload.deal.dealTermComment.commentGivenBy : e.payload.deal.salesPerson,
              dealTermComment: e.payload.deal.dealTermComment?e.payload.deal.dealTermComment: {
                userRole: "",commentDate: "",commentTXT: "", commentGivenBy: ""
              },
              writeupType: this.getWriteupType(e.payload),
              reviewManager: reviewManager,
              isToast:showToast
            },
            customer: { firstName: customer?.firstName ?? "", lastName: customer?.lastName ?? "" },
            cobuyer: { firstName: coBuyer?.firstName ?? "", lastName: coBuyer?.lastName ?? ""},
          }
        this._store.dispatch(appNotificationsActions.AppNotificationUpdate({payload: payload}));
        this._store.dispatch(appNotificationsActions.AppNotificationClearToasterMessages());
      }else if(e.payload.deal.salesPersonComments){
        this.notificationToast([e.payload], true);
        this._store.dispatch(appNotificationsActions.AddChatComment({ payload: e.payload }));
        this.hasComment = true;
        this.newMessage =true;
        this.cdRef.detectChanges();  
        clearInterval(this.messageInterval);
        this.startMessageBlink();
      }

    });
    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.CreditAppSubmitted).subscribe(e => {
      this._sharedDataService.toastChatType=false;
      const customer = e?.payload?.customer;
      const coBuyer = e?.payload?.cobuyer;
      const isOnlineCustomerComment = (e?.payload?.connectionId?.toLowerCase() === 'onlinecustomer')
        && (e?.payload?.deal?.salesPerson ?? '').toLowerCase() === 'customer';
      let submittedBy = e.payload.deal.salesPerson;
      if (isOnlineCustomerComment) {
          submittedBy = 'MSTC';
      }
        const payload = {
            deal: {
              creditFlag: e?.payload?.deal?.['creditFlag'],
              dealTransactionId: e?.payload?.deal?.dealTransactionId,
              dealType: null,
              paymentType: null,
              status: e.payload.deal.status,
              onlineStatus: e.payload.deal.onlineStatus,
              updatedDate: e?.payload?.activityTimeStamp,
              salesPersonComments: false,
              salesPerson: submittedBy,
              dealTermComment: null,
              writeupType: 'CREDIT APP SUBMITTED',
              reviewManager: null,
              isToast:true
            },
            customer: { firstName: customer?.firstName ?? "", lastName: customer?.lastName ?? "" },
            cobuyer: { firstName: coBuyer?.firstName ?? "", lastName: coBuyer?.lastName ?? ""},
          }
        if(this.featureFlagService.isFeatureEnabled('OCA_SUBMITTED')){
          this._store.dispatch(appNotificationsActions.AppNotificationUpdate({payload: payload}));
          this._store.dispatch(appNotificationsActions.AppNotificationClearToasterMessages());
        }

    });
    //
    // remove the notification if its viewed
    //
    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.DealView).subscribe(e => {
      this._store.dispatch(appNotificationsActions.AppNotificationRemove({payload: e.payload.deal.dealTransactionId}));
    });

    //store chat comments

    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.Chat).subscribe(webSocketEvent => {
      this.notificationToast([webSocketEvent.payload], true);
      this._store.dispatch(appNotificationsActions.AddChatComment({ payload: webSocketEvent.payload }));
    });
    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.ChatVisisted).subscribe(webSocketEvent => {
      let dealId;
      if (webSocketEvent.payload.type === 'DEAL_COMMENT_VISITED') {
        dealId = webSocketEvent.payload.deal.dealTransactionId
      }
      this.subs.sink = this._store.select(fromSelector.selectAppChatComments).subscribe(comments => {
        comments.forEach(c => {
          if (c.deal.dealTransactionId === dealId) {
            this._store.dispatch(appNotificationsActions.ClearChatComment({ payload: c}));
          }
        });
      });
    });
    //Listening OCA submission event
    this.subs.sink = this.webSocketManager.listen(SocketPayloadType.CreditAppSubmitted).subscribe(webSocketEvent => {
      if(this.featureFlagService.isFeatureEnabled('OCA_SUBMITTED')){
        this.notificationToast([webSocketEvent.payload], false);
      }
    });
    this.subs.sink = this._store.select(fromSelector.selectAppChatComments).subscribe(comments => {
      if(!isNil(this._sharedDataService.dealTransacId) && this._sharedDataService.dealTransacId.length >0){
        comments.forEach(c => {
          if (c.deal.dealTransactionId === this._sharedDataService.dealTransacId && this._sharedDataService.isNotesClicked)  {
            this._store.dispatch(appNotificationsActions.ClearChatComment({ payload: c }));
          }
        });
      }
      this.hasComment = comments.length > 0;
      this.newMessage =true;
      this.cdRef.detectChanges(); 
      clearInterval(this.messageInterval);
      this.startMessageBlink();
    });
  }

  private notificationToast(content, isComment?){
    const toastConfig = {
      toastComponent: ConAppToaster,
      payload: {},
      closeButton: true,
      timeOut: 10000
    }
    while (content.length > 0) {
      const toast = content.pop();
      if(isNil(toast.customer)){
        toast.customer = {firstName: '', lastName: ''};
      }
      if(isNil(toast.cobuyer)){
        toast.cobuyer = {firstName: '', lastName: ''};
      }
      if(isComment){
        if(toast.type === 'DEAL_UPDATE'){
          toast.deal.salesPerson = toast.salesPerson
        }
        else{
          toast.deal.salesPerson = toast.deal.dealTermComment.commentGivenBy;
        }
        toast.deal.writeupType = this.getWriteupType(toast);
        toast.deal.onlineStatus = this._sharedDataService.getOnlineStatus(toast.deal);
        toast.deal.status = 'Message';
        this._sharedDataService.toastChatType=true;
      }
      //
      // get additional parameters needed for writeup-details module
      //
      if (!this.router.url.includes('wd/writeup-detail')) {
        const toastData = {};
        const salesPerson = toast.deal.salesPerson.toUpperCase();
        const customer = toast?.customer;
        const cobuyer = toast?.cobuyer;
        const vehicle = toast?.deal?.vehicle ?? toast.vehicle;
        const writeupType = toast.deal.writeupType ?? '';
        const status = toast.deal.status ?? '';
        toastData['fullToastObject']=toast
        toastData['salesPerson'] = salesPerson;
        toastData['customerFullName'] = `${customer.firstName} ${customer.lastName} ${ cobuyer?.firstName ? `${cobuyer.firstName  } ${  cobuyer.lastName}` : ''}`;
        toastData['writeupType'] = writeupType.toUpperCase();
        toastData['status'] = status;
        if(toast.deal.status?.toLowerCase()==='Message'.toLowerCase()){
          toastData['vehicleInfo'] = `${vehicle?.modelYear ?? ''} ${vehicle?.brand ?? ''} ${vehicle?.modelMarketingName ?? ''}`.toUpperCase();
        }
        else{
          toastData['onlineStatus'] = toast?.deal?.onlineStatus
        }
        if(toast.type === 'OCA_SUBMITTED'){
          const toastCustomerFirstName = toast?.customer?.firstName?.trim();
          const toastCustomerLastName = toast?.customer?.lastName?.trim();
          const hasToastCustomerName = (!isNil(toastCustomerFirstName) && toastCustomerFirstName !== '') || (!isNil(toastCustomerLastName) && toastCustomerLastName !== '');
          const isOnlineCustomerCommentToast = (toast?.connectionId?.toLowerCase() === 'onlinecustomer')
            && (toast?.deal?.salesPerson ?? '').toLowerCase() === 'customer';
          let toastSalesPerson = (toast?.deal?.salesPerson ?? '');
           if(toast?.deal?.['sender'] === 'MSTC' || isOnlineCustomerCommentToast) {
            if (hasToastCustomerName) {
            toastSalesPerson = `${toastCustomerFirstName ?? ''} ${toastCustomerLastName ?? ''}`.trim().toUpperCase();
          }
          else {
            toastSalesPerson = 'MSTC';
          }
        }
          toastData['salesPerson'] = toastSalesPerson;
          toastData['vehicleInfo'] = null;
          toastData['writeupType'] = 'CREDIT APP SUBMITTED';
          toastData['status'] = '';
          toastData['onlineStatus'] = null;
        }
        toastConfig.payload = toastData;
        if(!this._sharedDataService.isUserSalesConsultant){
          this.audioService.playNotificationRingtone();
          // this.toasterService.popNotification(body, 'wd/writeup-detail', navExtra, true);
          this.toastrService.show(null, null, toastConfig);
        }
      }
    }
  }
  startBlink(){
    this.interval=setInterval(()=>{
      this.count=this.count+1
      if(this.count>=8){
        this.count=0;
        this.newNotification = false; 
        clearInterval(this.interval);
        
       }   
    }, 1000)
  }
  startMessageBlink(){
    this.messageInterval=setInterval(()=>{
      this.messagecount=this.messagecount+1
      if(this.messagecount>=8){
        this.messagecount=0;
        this.newMessage = false; 
        this.cdRef.detectChanges(); 
        clearInterval(this.messageInterval);
       }   
    }, 1000)
  }
  get getCarType() {
    //later if we need any specific access control on lexus we can open for now we are setting acces control at dealer level so commented below code and returning tru every time
    return true;
  }

  private getWriteupType(msg: SocketPayload): string {
    return this._sharedFuncService.getDealType(msg.deal);
  }
  //
  // return data required for navigating to writeup-details module
  //


  ///-------------------------------------------------------------
  //
  // ngOnDestroy
  //
  public ngOnDestroy() {
    this.subs.unsubscribe();
  }

  public logout() {
    this._sharedFuncService.logout(window);
  }

  openSuperMenu() {
    this._sharedDataService.superMenuToggleSubject.next(true);
    this.analyticsService.captureAnalytics(
      ViewConstants.EVENT_PAGE_LOAD,
      'Super Menu Modal',
      {
        globalBlock: {},
        pageBlock: {
          content_section: 'Super Menu Modal',
          content_subsection: "Write-ups",
          content_item: ''
        },
        linkBlock: {},
        dealerBlock: {},
        userBlock: {},
        vehicleBlock: {},
        tradeInVehicleBlock: {},
        customerBlock: {}
      }
    );
  }

  navigateToSummary(clickType) {
    if(!this._sharedDataService.iscalculateTriggered) {
      this._sharedDataService.setHideLoader(false);
      this.router.navigate([this.path]);
    } else {
      this.openunsaveWriteupsDialog = true;
      this._sharedDataService.isunsavedPopup = true;
         this.analyticsService.captureAnalytics('pageload', 'Customer Write-ups Alert', {
			'globalBlock': {}, 'pageBlock': { 'content_section': 'Customer Write-ups Alert Modal', 'content_subsection': '' }, 'linkBlock': ''})

      if(clickType === 'tab'){
      setTimeout(() => {
        if(document.getElementById("savedChanges-cancel"))
        {
          document.getElementById("savedChanges-cancel").focus();
        }
     }, 500);
    }
    }

    if(!this._sharedDataService.iscalculateTriggered) {
      if(this._sharedDataService.currentActiveTab === 'leads') {
        this._sharedDataService.summaryPageActiveTab.next('leads')
      } else if(this._sharedDataService.currentActiveTab === 'by customer') {
        this._sharedDataService.summaryPageActiveTab.next('by customer')
      } else {
        this._sharedDataService.summaryPageActiveTab.next('writeups')
      }
    }
    this._sharedDataService.selectedLenderforOnChangeRates= '';
    this._sharedDataService.selectedTermforOnChangeRates = [];
  }

  ContinueUnsaved(event){
    if(event && event === 'ok'){
      this._sharedDataService.iscalculateTriggered = false;
      this.openunsaveWriteupsDialog = false;
      this._sharedDataService.isunsavedPopup = false;
      this._modalService.dispatch({ action: 'close' });
      this._sharedDataService.setHideLoader(false);
      this.router.navigate([this.path]);
    }
  }

  public hideProfileTemplate(){
    this._sharedDataService.profileTemplateToggleSubject.next(false);
  }
  closeSuccessModal(event) {
    if (event === 'close') {
      this.openunsaveWriteupsDialog = false;
      document.getElementById('backIcon').focus();
      this._sharedDataService.isunsavedPopup = false;
      this._modalService.dispatch({ action: 'close' });
    }
  }
  public chatpanelopen=false
  OpenChat($event) {
    this.chatpanelopen = $event
    clearInterval(this.messageInterval);
  }
}




